var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 2,
    viewBox: "0 0 12 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6443 -6.21361e-05C11.3946 -0.00420409 12.0016 0.429577 12 0.969084C11.9982 1.50838 11.3886 1.94897 10.6384 1.95318C7.54425 1.96877 4.44989 1.98435 1.35572 1.99994C0.605496 2.00415 -0.00155955 1.5703 3.00977e-06 1.03086C0.00176089 0.491496 0.611454 0.0509049 1.36168 0.046763C4.45585 0.031178 7.55021 0.015593 10.6443 -6.21361e-05Z",
    fill: "#B99750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.7494205b34c648e3474aa66b3f937d82.svg";
export { ForwardRef as ReactComponent };